import { css } from "styled-components";

import { colorCSS } from "./colors";
import { redundantCssFromKebab } from "./redundant-css";

export const components: ReturnType<typeof css> = css`
    .tooltip-content {
        a {
            ${redundantCssFromKebab("color", `${colorCSS("N0")}`)}
        }
        p {
            ${redundantCssFromKebab("margin-block-end", "0.5rem")}
            &:last-child {
                ${redundantCssFromKebab("margin-block-end", "0")}
            }
        }
    }
`;
